export default __webpack_public_path__ + "static/media/Zone-4-Master-Plan-Type-H.c23897ca.png";